export default {
    validate(value) {
        return !!value.trim().match(new RegExp(/^(?=.*[a-zA-Z])(?=.*?[#?!@$%^&*-])(?=.*?[0-9])/))
    },
    message: () => 'A senha informada deve conter ao menos um caractere alfabético e um caractere numérico',
}